/// <amd-module name="Search/Shared/Components/TimeoutComponent/index" />
export * from "./TimeoutComponent";
export * from "./TimeoutComponent.Props";
